import React, { ReactElement, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import { CSSTransitionProps } from "react-transition-group/CSSTransition";

type Props = CSSTransitionProps & {
    // intended behavior: https://github.com/facebook/react/issues/31824
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: ReactElement<any>;
};

function CSSTransitionWithRef({
    children,
    ...restProps
}: Props): React.JSX.Element {
    const nodeRef = useRef<HTMLDivElement>(null);

    return (
        <CSSTransition nodeRef={nodeRef} {...restProps}>
            <div ref={nodeRef}>{children}</div>
        </CSSTransition>
    );
}

export { CSSTransitionWithRef };
